var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserProfile = function SvgUserProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "user-profile_svg__a",
    cx: 512,
    cy: 512,
    r: 512
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#user-profile_svg__a",
    style: {
      overflow: "visible",
      fill: "#dee1e6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "user-profile_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#user-profile_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      clipPath: "url(#user-profile_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 657.5c-107 0-193.7-95-193.7-212.2S405 233.1 512 233.1s193.7 95 193.7 212.2S619 657.5 512 657.5",
    style: {
      fill: "#555f70"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M511.9 694.8c-168.6 0-308 124.8-330.9 287 0 0 133.9 52.3 330.9 52.3s331-51.4 331-51.4c-22.5-162.7-162.1-287.9-331-287.9",
    style: {
      opacity: 0.8,
      clipPath: "url(#user-profile_svg__b)",
      fill: "#555f70"
    }
  }));
};
export default SvgUserProfile;